import { UserRole } from "./user-role.js";
export const Permission = {
    GET_COMPANY_DETAILS: "GET_COMPANY_DETAILS",
    GET_APPLICANT_DETAILS: "GET_APPLICANT_DETAILS",
    REGISTER_WORK_APPLICANT_DATA: "REGISTER_WORK_APPLICANT_DATA",
    EDIT_COMPANY_PROFILE: "EDIT_COMPANY_PROFILE",
    EDIT_APPLICANT_WORK_DATA: "EDIT_APPLICANT_WORK_DATA",
    VIEW_ADMIN_DASHBOARD: "VIEW_ADMIN_DASHBOARD",
    CREATE_CERTIFICATION: "CREATE_CERTIFICATION",
    DELETE_CERTIFICATION: "DELETE_CERTIFICATION",
    CREATE_PUBLICATION: "CREATE_PUBLICATION",
    DELETE_PUBLICATION: "DELETE_PUBLICATION",
    UPDATE_PUBLICATION: "UPDATE_PUBLICATION",
    REGENERATE_APIKEY: "REGENERATE_APIKEY",
    ADD_CERTIFICATION: "ADD_CERTIFICATION",
    REMOVE_CERTIFICATION: "REMOVE_CERTIFICATION",
    EDIT_CERTIFICATION: "EDIT_CERTIFICATION",
    VIEW_APPLICANTS: "VIEW_APPLICANTS",
    VIEW_APPLICANTS_APPLICATIONS: "VIEW_APPLICANTS_APPLICATIONS",
};
export const DefaultPermissionsByRole = {
    [UserRole.ADMIN]: [
        Permission.VIEW_ADMIN_DASHBOARD,
        Permission.CREATE_CERTIFICATION,
        Permission.DELETE_CERTIFICATION,
        Permission.VIEW_APPLICANTS,
        Permission.EDIT_CERTIFICATION,
        Permission.REGENERATE_APIKEY,
        Permission.ADD_CERTIFICATION,
    ],
    [UserRole.COMPANY]: [
        Permission.GET_COMPANY_DETAILS,
        Permission.EDIT_COMPANY_PROFILE,
        Permission.CREATE_PUBLICATION,
        Permission.UPDATE_PUBLICATION,
        Permission.DELETE_PUBLICATION,
        Permission.REGENERATE_APIKEY,
        Permission.REMOVE_CERTIFICATION,
        Permission.EDIT_CERTIFICATION,
        Permission.VIEW_APPLICANTS,
        Permission.ADD_CERTIFICATION,
        Permission.VIEW_APPLICANTS_APPLICATIONS,
    ],
    [UserRole.APPLICANT]: [
        Permission.GET_APPLICANT_DETAILS,
        Permission.EDIT_APPLICANT_WORK_DATA,
    ],
};
